import styled from 'styled-components';
import { Menu } from '@/ui';

export const StyledMenu = styled(Menu)`
  width: 100%;
`;
